import { render, staticRenderFns } from "./BCRLinkStatus.vue?vue&type=template&id=38f257fd&scoped=true&"
import script from "./BCRLinkStatus.vue?vue&type=script&lang=js&"
export * from "./BCRLinkStatus.vue?vue&type=script&lang=js&"
import style0 from "./BCRLinkStatus.vue?vue&type=style&index=0&id=38f257fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f257fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VProgressCircular,VRow})
